export default __webpack_public_path__ + "static/media/logo_lobarnechea.09b2e6ec.png";